module.exports = __webpack_public_path__ + "page_3_bc.9bb10ea2.png";